module.exports = __webpack_public_path__ + "html/fonts/ionicons.143146f.woff2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/_view-design@4.3.2@view-design/dist/styles/fonts/ionicons.woff2?v=3.0.0
// module id = j3IL
// module chunks = 81 82 83 84 85